<template>
  <!-- 学校风采 -->
  <div class="index-container">
    <bannerImg :bannerText="bannerText" :isShowTab="true"></bannerImg>
    <div class="index-content">
      <div class="condition-box">
        <span class="c-front">
          分类筛选：
          <span>|</span>
        </span>

        <el-checkbox-group v-model="checkList" @change="categoryChange">
          <el-checkbox
            v-for="(item,index) in categoryList"
            :key="'cate' + index"
            :label="item.uuid"
          >{{item.title}}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="show-content">
        <div class="show-left">
          <div
            class="show-img"
            @click="goDetail(topList)"
            :style="{ backgroundImage: 'url( ' + imgUrl + topList.thumb + ')' }"
          >
            <div class="show-title">
              <div>{{topList.create_time}}</div>
              {{topList.title}}
            </div>
          </div>
          <div
            class="show-list"
            v-for="(item,index) in showList"
            @click="goDetail(item)"
            :key="'show'+index"
          >
            <div class="list-img" :style="{ backgroundImage: 'url( ' + imgUrl + item.thumb + ')' }"></div>
            <div class="right-info">
              <div class="list-title">{{item.title}}</div>
              <div class="num-box">
                <i class="iconfont el-icon-view"></i>
                {{item.pv}}
                <i class="iconfont el-icon-chat-line-square"></i>
                {{item.comment_count}}
              </div>
              <div class="list-date">{{item.create_time}}</div>
              <div class="look-btn">查看详情</div>
            </div>
          </div>
        </div>
        <div class="show-right">
          <div class="module-box">
            <div class="module-title">热门动态</div>
            <div
              class="hot-list"
              @click="goDetail(item)"
              v-for="(item,index) in hotList"
              :key="'hot'+index"
            >
              <div
                class="hot-img"
                :style="{ backgroundImage: 'url( ' + imgUrl + item.thumb + ')' }"
              ></div>
              <div class="hot-name">{{item.title}}</div>
            </div>
          </div>
          <div class="module-box">
            <div class="module-title">大家都爱看</div>
            <div class="type-list-box">
              <div
                class="type-list"
                @click="typeSelect(item,index)"
                v-for="(item,index) in typeList"
                :key="'type'+index"
                :class="typeIndex === index?'type-active':''"
              >{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        :page-size="page_size"
        :total="listTotal"
        :current-page.sync="page_index"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import bannerImg from '../components/bannerImg.vue';
import picture from '@/assets/img/picture.png';
import api from '../api/api';
import { imgUrl } from '../api/index';

export default {
  name: 'schoolShow',
  components: {
    bannerImg
  },
  data() {
    return {
      imgUrl: imgUrl,
      bannerText: '学校风采',
      checkList: [],
      showList: [],
      listTotal: 0,
      hotList: [],
      typeList: [],
      typeIndex: '',
      detailImg: picture,
      categoryList: [],
      page_size: 6,
      page_index: 1,
      topList: {}
    };
  },
  mounted() {
    scrollTo(0, 0);
  },
  created() {
    this.getArticleType();
    this.getArticleList();
  },
  methods: {
    // 类别选择
    categoryChange(val) {
      console.log(val);
      this.checkList = val;
      this.getArticleList();
    },
    // 获取类别
    getArticleType() {
      api.getArticleType().then(res => {
        console.log(res);
        if (res.result && res.result.data) {
          this.categoryList = res.result.data;
        } else {
          this.$message.warning(res.result.msg);
        }
      });
    },
    // 页码改变
    handleCurrentChange(val) {
      this.page_index = val;
      this.getArticleList();
    },
    // 获取列表
    getArticleList() {
      let cateStr = '';
      this.checkList.forEach(ele => {
        if (cateStr) {
          cateStr = cateStr + ',' + ele;
        } else {
          cateStr = ele;
        }
      });
      console.log(cateStr);
      const params = {
        type: '1',
        cate_uuid: cateStr,
        page_size: this.page_size,
        page_index: this.page_index
      };
      api.getArticleList(params).then(res => {
        console.log(res);
        if (res.result && res.result.data) {
          this.showList = res.result.data;
          this.listTotal = res.result.total;
          this.hotList = res.result.hot;
          this.typeList = res.result.love;
          this.topList = res.result.top;
        } else {
          this.$message.warning(res.result.msg);
        }
      });
    },
    typeSelect(item, index) {
      this.typeIndex = index;
      this.checkList.push(item.uuid);
      this.getArticleList();
    },
    goDetail(item) {
      this.$router.push({ path: '/showDetail', query: { id: item.uuid } });
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.index-content {
  width: 72%;
  padding: 35PX 16PX;
  margin: 50PX auto 0;
  background-color: #ffffff;
}
.condition-box {
  display: flex;
  align-items: center;
  margin-left: 30PX;
  font-size: 16PX;
  color: #242424;
  span {
    padding: 0 40PX 0 30PX;
  }
  .c-front {
    flex-shrink: 0;
    padding: 0;
  }
}
/deep/ {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #f1a373;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #f1a373;
    border-color: #f1a373;
  }
  .el-checkbox__inner:hover {
    border-color: #f1a373;
  }
  .el-checkbox__inner {
    width: 16PX;
    height: 16PX;
  }
  .el-checkbox,
  .el-checkbox__label {
    font-size: 16PX;
  }
  .el-checkbox__inner::after {
    top: 2PX;
    left: 5PX;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fb6d0a;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ffffff;
    background-color: #fb6d0a;
  }
  .el-pagination {
    margin-bottom: 80PX;
    text-align: center;
    button {
      width: 42PX;
      height: 42PX;
    }
  }
  .el-pager li {
    width: 42PX;
    height: 42PX;
    line-height: 42PX;
  }
}
.show-content {
  display: flex;
  padding: 46PX 0;
  justify-content: space-between;
}
.show-left {
  width: 70%;
  margin-right: 35PX;
  .show-img {
    position: relative;
    width: 94%;
    height: 338PX;
    margin: 0 auto 28PX;
    background-color: antiquewhite;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .show-title {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 10PX 20PX;
    font-size: 24PX;
    color: #ffffff;
    font-weight: 500;
    letter-spacing: 2PX;
    background-color: rgba($color: #000000, $alpha: 0.5);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    > div {
      font-size: 12PX;
      color: #cacaca;
    }
  }
}
.show-list {
  display: flex;
  padding: 20PX 20PX 44PX 28PX;
  margin-bottom: 20PX;
  border-bottom: 1PX solid #ebebeb;
  cursor: pointer;
  &:hover {
    background-color: #f9f9f9;
    .list-title {
      color: #f6ab2b;
    }
    .look-btn {
      color: #ffffff;
      background: #f6ab2b;
    }
  }
  .list-img {
    width: 295PX;
    height: 186PX;
    background-color: antiquewhite;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
  }
  .right-info {
    padding-left: 34PX;
  }
  .list-title {
    margin-bottom: 20PX;
    font-size: 18PX;
    color: #252525;
    line-height: 30PX;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .num-box {
    position: relative;
    padding-bottom: 32PX;
    color: #666666;
    .iconfont {
      position: relative;
      top: 3PX;
    }
  }
  .el-icon-chat-line-square {
    padding-left: 16PX;
  }
  .list-date {
    padding-bottom: 14PX;
    font-size: 12PX;
    color: #5f5f5f;
  }
  .look-btn {
    width: 74PX;
    height: 25PX;
    font-size: 12PX;
    color: #88837b;
    line-height: 25PX;
    text-align: center;
    background: #f5f1ea;
    border-radius: 3PX;
  }
}
.show-right {
  width: 28%;
}
.module-box {
  padding: 30PX 22PX 10PX;
  margin-bottom: 18PX;
  background: #f9f9f9;
  .module-title {
    position: relative;
    margin-bottom: 26PX;
    font-size: 18PX;
    color: #f6ab2b;
    font-weight: 500;
    &::before {
      position: absolute;
      top: 4PX;
      left: -22PX;
      width: 4PX;
      height: 17PX;
      background-color: #f6ab2b;
      content: '';
    }
  }
  .hot-list {
    display: flex;
    align-items: center;
    margin-bottom: 30PX;
    cursor: pointer;
    &:hover {
      .hot-name {
        color: #fb6d0a;
      }
    }
  }
  .hot-img {
    flex-shrink: 0;
    width: 50%;
    height: 85PX;
    margin-right: 20PX;
    background-color: antiquewhite;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .hot-name {
    color: #2e2d2d;
    line-height: 24PX;
  }
}
.type-list-box {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 60PX;
  .type-list {
    padding: 0 24PX;
    margin: 0 8PX 20PX 0;
    line-height: 38PX;
    color: #666666;
    text-align: center;
    background: #ffffff;
    border-radius: 19PX;
    cursor: pointer;
    &:hover {
      color: #fb6d0a;
      background: #f9f1e4;
    }
  }
  .type-active {
    color: #fb6d0a;
    background: #f9f1e4;
  }
}
@media screen and (max-width: 1600PX) {
  .index-content {
    width: 96%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/schoolShow.vue